import { render } from "./AddOnList.vue?vue&type=template&id=72aa103b"
import script from "./AddOnList.vue?vue&type=script&lang=js"
export * from "./AddOnList.vue?vue&type=script&lang=js"
script.render = render

export default script

/* vue-cli-plugin-import-components */
import Dropdown from "@/components/Dropdown.vue";
import AddOnListItem from "@/components/AddOnListItem.vue";
script.components = Object.assign({}, { Dropdown, AddOnListItem }, script.components);